module.exports = __webpack_public_path__ + "img/glassquality_1.d44b3447.png";